// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contrast {
  background-color: black;
}
.contrast nav,
.contrast div,
.contrast ul,
.contrast li,
.contrast header,
.contrast footer,
.contrast section,
.contrast main,
.contrast aside,
.contrast form,
.contrast article,
.contrast body,
.contrast #optional-content .document-form,
.contrast .rectify-container .rectify-collapse .ant-collapse {
  background: black !important;
  color: white !important;
}
.contrast h1,
.contrast h2,
.contrast h3,
.contrast h4,
.contrast h5,
.contrast h6,
.contrast p,
.contrast label,
.contrast strong,
.contrast em,
.contrast cite,
.contrast q,
.contrast i,
.contrast b,
.contrast u {
  color: white !important;
}
.contrast .panel .finger-prints .finger-print .overlay h3,
.contrast .panel .finger-prints .finger-print .overlay span {
  color: #000 !important;
}
.contrast ul {
  background: black !important;
}
.contrast li:hover {
  background-color: white;
  color: black;
}
.contrast span svg {
  color: black;
}
.contrast a,
.contrast .data-row span {
  background: black !important;
  color: yellow !important;
}
.contrast .ant-form-item-explain-error {
  color: yellow !important;
}
.contrast form,
.contrast #optional-content .document-form {
  border: 1px solid white !important;
}
.contrast form {
  border-radius: 15px;
}
.contrast input[type=search] {
  color: black !important;
}
.contrast input[type=url],
.contrast input[type=email],
.contrast input[type=tel],
.contrast input[type=date],
.contrast input[type=month],
.contrast input[type=week],
.contrast input[type=datetime],
.contrast input[type=datetime-local] {
  border: 1px solid white;
  color: white !important;
  background: black !important;
}
.contrast img.on-contrast-force-gray {
  filter: grayscale(100%) contrast(120%) !important;
}
.contrast .img-hand-right img,
.contrast .img-hand-left img,
.contrast img.on-contrast-force-white,
.contrast .coleta-data-body-especial .signature {
  filter: brightness(0) invert(1) !important;
}
.contrast span {
  color: white !important;
}
.contrast .ant-form-item-explain.ant-form-item-explain-error div,
.contrast .accessibitity-title span {
  color: yellow !important;
}
.contrast .accessibility-bar ul li a.item-accessibility span {
  color: yellow;
}
.contrast .footer .content .infos li img {
  filter: brightness(5);
}
.contrast .card-item .card-text h4.title span {
  color: yellow;
}
.contrast .contrast .card-item .card-text h3 {
  color: white;
}
.contrast .ant-dropdown ul li {
  background-color: black !important;
}
.contrast .ant-dropdown ul li:hover span {
  color: yellow;
  background-color: black !important;
}
.contrast .ant-tooltip-inner {
  color: #fff;
  background-color: rgba(0, 0, 0, 0.75);
  border: 1px solid yellow;
}
.contrast .ant-tooltip-arrow-content {
  background-color: yellow;
}
.contrast .ant-modal {
  background-color: transparent !important;
}
.contrast .ant-modal .ant-radio-group.ant-radio-group-solid {
  padding-top: 1rem;
}
.contrast .ant-modal div {
  border: none;
  border-radius: 30px;
}
.contrast .ant-modal .ant-modal-close:hover {
  background-color: transparent;
}
.contrast .ant-modal .ant-modal-close svg {
  color: yellow;
}
.contrast .ant-modal .ant-modal-content {
  border: 1px solid white !important;
  border-radius: 30px !important;
  background-color: black !important;
}
.contrast .ant-modal .ant-modal-content form {
  border: none !important;
}
.contrast .ant-modal .ant-modal-content form span {
  color: white;
}
.contrast .ant-input-group-addon {
  border: 1.5px solid #d9d9d9 !important;
}
.contrast .ant-card-bordered {
  border-width: 2px;
}
.contrast .ant-menu li span a span {
  color: white;
}
.contrast .ant-table-column-sort {
  color: black;
}
.contrast .ant-table-tbody tr.ant-table-row td button span svg {
  color: white;
}
.contrast .ant-table-tbody tr.ant-table-row:hover td button span svg {
  color: black !important;
}
.contrast .ant-table-tbody tr.ant-table-row:hover td button:hover span svg {
  color: white !important;
}
.contrast .ant-table-tbody tr.ant-table-row:hover > td.ant-table-cell {
  background: #fafafa !important;
  color: black;
}
.contrast .ant-table-tbody tr.ant-table-row:focus-within > td.ant-table-cell,
.contrast .ant-table-tbody tr.ant-table-row:focus-within > td.ant-table-cell span {
  color: black;
}
.contrast .ant-table-tbody tr.ant-table-row:hover > td.ant-table-cell span {
  color: black !important;
}
.contrast span.ant-tag-warning {
  background: white;
  margin: 0 10px;
}
.contrast span.ant-tag-warning span {
  color: black;
}
.contrast td.ant-table-cell.ant-table-cell-fix-right.ant-table-cell-fix-right-first {
  background: black;
  z-index: 1;
}
.contrast table tr td div {
  background: transparent !important;
}
.contrast table tr td span span {
  background: transparent !important;
}
.contrast table tr:hover td div {
  color: black !important;
}
.contrast table tr:hover td button:hover {
  background-color: transparent;
}
.contrast table tr:hover td button svg {
  color: black !important;
}
.contrast table tr::selection td div {
  color: black !important;
}
.contrast table tr .date-three-week,
.contrast table tr .date-two-week,
.contrast table tr .date-three-week {
  background-color: #db3236 !important;
}
.contrast .ant-table-column-sorters span svg {
  color: white !important;
}
.contrast .ant-table-column-sorters .active svg {
  color: #fd820f !important;
}
.contrast .ant-table-thead th.ant-table-column-has-sorters {
  background: black;
}
.contrast .ant-select-arrow .anticon > svg {
  color: #637178 !important;
}
.contrast .ant-input,
.contrast .ant-input-affix-wrapper {
  background-color: white !important;
  color: #000;
}
.contrast .ant-input:focus,
.contrast .ant-input-focused,
.contrast .ant-select:focus,
.contrast .ant-select-focused,
.contrast .ant-input-number:focus,
.contrast .ant-input-number-focused,
.contrast .ant-input-affix-wrapper:focus,
.contrast .ant-input-affix-wrapper-focused,
.contrast .ant-picker:focus,
.contrast .ant-picker-focused {
  box-shadow: 0 0 0 2px rgba(0, 168, 74, 0.5) !important;
  border-radius: 2px;
  color: #000;
}
.contrast .page-content-login .container-login .ant-input {
  color: black;
}
.contrast .ant-menu span svg {
  color: #00a84a !important;
}
.contrast .manager-header .icon-table svg {
  color: #00a84a !important;
}
.contrast .ant-tag-volcano {
  color: #d4380d !important;
  background: #fff2e8 !important;
  border-color: #ffbb96 !important;
}
.contrast .ant-tag-green {
  color: #389e0d !important;
  background: #f6ffed !important;
  border-color: #b7eb8f !important;
}
.contrast .textual-data .data-item div,
.contrast .textual-data .data-item span {
  color: #fff !important;
}
.contrast .textual-data .data-item h3 {
  color: yellow !important;
}
.contrast .ant-switch-handle {
  background: transparent !important;
}
.contrast .ant-modal-content {
  background-color: #fff !important;
}
.contrast .ant-modal-confirm-warning .ant-modal-confirm-body .anticon,
.contrast .ant-modal-confirm-confirm .ant-modal-confirm-body .anticon {
  color: #faad14 !important;
}
.contrast .ant-modal-confirm-body .ant-modal-confirm-title {
  color: whitesmoke;
}
.contrast .ant-input-search > .ant-input-group > .ant-input-group-addon:last-child {
  left: 4px;
}
.contrast .ant-switch {
  background-color: #cecece !important;
}
.contrast .ant-notification {
  background-color: transparent !important;
}
.contrast .ant-notification div {
  background-color: transparent !important;
}
.contrast .ant-notification .ant-notification-notice {
  position: relative;
  width: 384px;
  max-width: calc(100vw - 48px);
  margin-bottom: 16px;
  margin-left: auto;
  padding: 16px 24px;
  overflow: hidden;
  line-height: 1.5715;
  word-wrap: break-word;
  background: #fff !important;
}
.contrast .ant-notification .ant-notification-notice .ant-notification-notice-close {
  background: transparent !important;
  color: rgba(0, 0, 0, 0.45) !important;
}
.contrast .ant-notification .ant-notification-notice .ant-notification-notice-message {
  color: rgba(0, 0, 0, 0.85) !important;
}
.contrast .ant-picker-time-panel-column > li.ant-picker-time-panel-cell-selected .ant-picker-time-panel-cell-inner {
  border: 1px solid yellow !important;
}
.contrast .ant-input-number-handler-wrap,
.contrast .ant-picker,
.contrast .ant-picker-input,
.contrast .ant-input-number-input-wrap,
.contrast .ant-input-number,
.contrast .ant-select {
  background: #fff !important;
  color: #000 !important;
}
.contrast .ant-switch-checked {
  background: #00a84a !important;
}
.contrast .dashboard-container .dashboard-content {
  overflow: hidden;
}
.contrast .dashboard-container .dashboard-content .ant-steps .ant-steps-icon-dot {
  z-index: 9999 !important;
}
.contrast .dashboard-container .dashboard-content .ant-steps .ant-steps-item-tail {
  background: white !important;
  z-index: 10;
}
@media (max-width: 576px) {
  .contrast .dashboard-container .dashboard-content .ant-steps .ant-steps-item-tail {
    background: black !important;
  }
}
.contrast .dashboard-container .dashboard-content .ant-steps .ant-steps-icon .anticon-check {
  z-index: 9999;
}
.contrast .dashboard-container .dashboard-content .ant-steps .ant-steps-icon .anticon-check svg {
  z-index: 9999;
  color: white !important;
}
.contrast .ant-steps-item.ant-steps-item-process.ant-steps-item-active span.anticon {
  display: none !important;
}
.contrast .request-form-content .ant-steps-item-process .ant-steps-item-icon {
  background-color: #00a84a !important;
  z-index: 9 !important;
}
.contrast .request-form-content .ant-steps-item-icon {
  position: relative !important;
  z-index: 9 !important;
}
.contrast .location-search div {
  background: white !important;
}
.contrast .local-selection .location-search .ant-input-affix-wrapper {
  box-shadow: none !important;
  background-color: #fff !important;
}
.contrast .page-content .request-to-other-horizontal-form,
.contrast .page-content .request-type-horizontal-form,
.contrast .scheduling-content form,
.contrast form.ant-form-vertical,
.contrast .contrast .ant-input-group-addon,
.contrast .notification .notification-manager:nth-child(1) {
  border: none !important;
}
.contrast .local-selection {
  border: 1px solid;
}
.contrast .ant-radio-button-wrapper {
  background: #000;
}
.contrast .ant-modal-mask {
  background-color: rgba(0, 0, 0, 0.45) !important;
}
.contrast .start {
  background-color: #00a84a !important;
}
.contrast .middle {
  background-color: #ee9e00 !important;
}
.contrast .end {
  background-color: #f84d4d !important;
}
.contrast .request-form-content span {
  color: white !important;
}
.contrast .ant-picker-content tr .ant-picker-cell .ant-picker-cell-inner {
  background: none;
  color: white !important;
}
.contrast .ant-picker-cell-in-view.ant-picker-cell-range-start:not(.ant-picker-cell-range-start-single)::before,
.contrast .ant-picker-cell-in-view.ant-picker-cell-in-range::before,
.contrast .ant-picker-dropdown .ant-picker-cell-selected .ant-picker-cell-inner {
  background-color: #00a84a !important;
}
.contrast .ant-picker-cell-disabled {
  background-color: #cecece;
}
.contrast .ant-picker-header button span {
  color: yellow !important;
}
.contrast .ant-picker-range-separator {
  background-color: white !important;
}
.contrast .ant-select-selector .ant-select-selection-item {
  color: #637178 !important;
}
.contrast .ant-select-selector span {
  color: #6d7a7c !important;
}
.contrast span.required {
  color: #ff4d4f !important;
}
.contrast .ant-upload-list-item-info .ant-upload-list-item-name span {
  color: white !important;
}
.contrast .optional-documents span {
  color: white !important;
}
.contrast .ant-table-column-sorters {
  background: transparent !important;
}
.contrast .ant-table-column-sorters span {
  color: #333 !important;
}
.contrast .ant-table-row .ant-table-column-sort {
  background-color: transparent !important;
  color: #fff;
}
.contrast .background-login {
  /* background-image: url('./../assets/img/illustration.png') !important;
  background-repeat: no-repeat !important;
  background-size: contain !important;
  background-position: 30% 50% !important; */
}
.contrast .page-content-login {
  background: transparent !important;
}
.contrast .ant-breadcrumb span.ant-breadcrumb-link a {
  color: white !important;
}
.contrast .ant-breadcrumb span {
  color: yellow !important;
}
.contrast .ant-modal-content .ant-modal-body .ant-btn-primary {
  background-color: #00a84a;
  border-color: #00a84a !important;
}
.contrast .ant-modal .ant-btn .ant-btn-primary span {
  color: #fff !important;
}
.contrast .ant-modal .ant-btn .secondary-button span {
  color: #000 !important;
}
.contrast .ant-modal-wrap {
  background: transparent !important;
}
.contrast .anticon-search svg {
  color: #333 !important;
}
.contrast .panel .finger-prints .finger-print .overlay,
.contrast .finger-print .selected,
.contrast .panel .finger-prints .finger-print,
.contrast .panel .finger-prints .finger-print .overlay .ant-notification-notice-message,
.contrast .content-top,
.contrast .box-footer,
.contrast .rg-content,
.contrast .grid-template-areas,
.contrast .grid-template-areas > *,
.contrast .photo > .img,
.contrast .signature-content,
.contrast .signature-content .img,
.contrast .director-signature-content,
.contrast .director-signature-content .img,
.contrast .grid-template-areas-bottom-right > *,
.contrast .grid-template-areas-top-right > *,
.contrast .grid-template-areas-bottom-right,
.contrast .grid-template-areas-top-right,
.contrast .resume-form .card-style-with-border,
.contrast .rg-mirror,
.contrast .coleta-data-body-especial,
.contrast .coleta-data-body,
.contrast .collect-data .header,
.contrast .ant-modal-footer,
.contrast .ant-modal-header,
.contrast .request-data > .actions,
.contrast .request-content,
.contrast .request-content .textual-data,
.contrast .request-data .header,
.contrast .ant-select-selection-overflow,
.contrast .ant-select-selection-overflow-item,
.contrast .ant-select-selection-overflow-item.ant-select-selection-overflow-item-suffix,
.contrast .ant-select-selection-search,
.contrast .ReactCrop__crop-selection,
.contrast .document .form,
.contrast .ant-back-top-icon span,
.contrast .ant-back-top-content,
.contrast .ant-back-top,
.contrast .ant-picker-cell-in-view.ant-picker-cell-range-end:not(.ant-picker-cell-range-end-single)::before {
  background-color: transparent !important;
}
.contrast .ant-back-top-icon span svg {
  color: yellow !important;
}
.contrast .select-container .actions-select {
  background-color: #f1f3f4 !important;
}
.contrast .demands-form {
  padding: 1%;
}
.contrast .observation-item span,
.contrast .ant-modal-close-x span,
.contrast .finish-info h3 span {
  color: yellow !important;
}
.contrast .observation-item span svg,
.contrast .ant-modal-close-x span svg,
.contrast .finish-info h3 span svg {
  color: yellow !important;
}
.contrast .icon-back span svg,
.contrast .left-container span svg {
  color: white !important;
}
.contrast .location-name span svg,
.contrast .ant-btn-link span {
  color: yellow !important;
}
.contrast .ant-pagination button span svg,
.contrast .header-title button span svg,
.contrast .actions button svg {
  color: #333 !important;
}
.contrast .actions button:hover svg,
.contrast .ant-upload-text-icon svg {
  color: #fff !important;
}
.contrast .ant-pagination button:hover span svg {
  color: #fff !important;
}
.contrast .header .status span.valid svg {
  color: #3cba54 !important;
}
.contrast .header .status span.invalid svg {
  color: #db3236 !important;
}
.contrast .header .status span.doubt svg {
  color: #722ed1 !important;
}
.contrast .header .status span.pending svg {
  color: #f4c20d !important;
}
.contrast .ant-modal-content .validation-itens .box-style-with-border,
.contrast .ant-modal-content .validation-itens .box-style-with-border-and-padding {
  border-radius: 14px !important;
  border: 1.5px solid #e5e7ec !important;
}
.contrast .grid-template-areas .name {
  background: transparent !important;
}
.contrast .request-page .ant-tabs .ant-tabs-ink-bar {
  background-color: yellow !important;
  top: 0;
}
.contrast .titleContainer,
.contrast .observation-item h3,
.contrast .historic-item h3,
.contrast .request-page .ant-tabs-nav .ant-tabs-tab-active,
.contrast .request-page .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn,
.contrast .request-page .ant-tabs-tab-btn:focus {
  color: yellow !important;
}
.contrast .observation-content .observation-item span,
.contrast .observation-content .observation-item h4,
.contrast .historic-item span,
.contrast .historic-item h4,
.contrast .request-page .ant-tabs-nav,
.contrast .request-page .ant-tabs-tab-btn {
  color: white !important;
}
.contrast .card-style-with-border,
.contrast .card-style-with-border-and-padding {
  border-radius: 30px !important;
  box-shadow: 0px 2px 10px #cecece !important;
  z-index: 9;
}
.contrast .ant-upload-list-item-info span,
.contrast .modal-optional-documents .form-optional-documents .optional-documents .ant-checkbox-wrapper span,
.contrast .modal-optional-documents .form-optional-documents .health-condition .ant-checkbox-wrapper span {
  color: #fff !important;
}
.contrast .modal-optional-documents .form-optional-documents .health-condition {
  border-top: none !important;
}
.contrast .cancel-button {
  background-color: transparent !important;
}
.contrast .cancel-button span {
  color: #fff !important;
}
.contrast .ant-modal-confirm-body-wrapper .warning-icon svg {
  color: red !important;
}
.contrast .request-data.DOUBT .header,
.contrast .request-data.DOUBT .header-subtitle,
.contrast .request-data.DOUBT .request-content,
.contrast .request-data.DOUBT .actions-row,
.contrast .request-data.DOUBT .actions,
.contrast .request-data.PENDING .header,
.contrast .request-data.PENDING .header-subtitle,
.contrast .request-data.PENDING .request-content,
.contrast .request-data.PENDING .actions-row,
.contrast .request-data.PENDING .actions,
.contrast .request-data.ALTERED .header,
.contrast .request-data.ALTERED .header-subtitle,
.contrast .request-data.ALTERED .request-content,
.contrast .request-data.ALTERED .actions-row,
.contrast .request-data.ALTERED .actions,
.contrast .request-data.ACCEPT .header,
.contrast .request-data.ACCEPT .header-subtitle,
.contrast .request-data.ACCEPT .request-content,
.contrast .request-data.ACCEPT .actions-row,
.contrast .request-data.ACCEPT .actions,
.contrast .request-data.FORGOTTEN .header,
.contrast .request-data.FORGOTTEN .header-subtitle,
.contrast .request-data.FORGOTTEN .request-content,
.contrast .request-data.FORGOTTEN .actions-row,
.contrast .request-data.FORGOTTEN .actions,
.contrast .request-data.REJECT .header,
.contrast .request-data.REJECT .header-subtitle,
.contrast .request-data.REJECT .request-content,
.contrast .request-data.REJECT .actions-row,
.contrast .request-data.REJECT .actions {
  background-color: transparent !important;
}
.contrast .request-data .actions .document-btn {
  border: 2px solid #fff !important;
}
.contrast .request-data .actions .document-btn span {
  color: #fff !important;
}
.contrast .request-data .actions .doubt span {
  color: #722ed1 !important;
}
.contrast .request-data .actions .doubt.selected {
  background-color: #722ed1 !important;
}
.contrast .request-data .actions .doubt.selected span {
  color: #000 !important;
}
.contrast .request-data .actions .valid span {
  color: #3cba54 !important;
}
.contrast .request-data .actions .valid.selected {
  background-color: #3cba54 !important;
}
.contrast .request-data .actions .valid.selected span {
  color: #000 !important;
}
.contrast .request-data .actions .invalid span {
  color: #db3236 !important;
}
.contrast .request-data .actions .invalid.selected {
  background-color: #db3236 !important;
}
.contrast .request-data .actions .invalid.selected span {
  color: #000 !important;
}
.contrast .request-data .justificative {
  padding: 15px;
  display: block;
  background-color: #db3236 !important;
}
.contrast .request-data .doubt-box {
  background-color: #722ed1 !important;
}
.contrast .justificative-modal .ant-modal-body .doubt-area {
  color: #fff !important;
  background-color: transparent !important;
}
.contrast .justificative-modal .ant-modal-body .doubt-area:focus {
  border-color: #fff !important;
}
.contrast .anticon.ant-notification-notice-icon-success svg {
  color: #52c41a !important;
}
.contrast .anticon.ant-notification-notice-icon-warning svg {
  color: #faad14 !important;
}
.contrast .anticon.ant-notification-notice-icon-error svg {
  color: #ff4d4f !important;
}
.contrast button span {
  color: black;
}
.contrast button span svg {
  color: white !important;
}
.contrast button:hover {
  color: white;
  background-color: black;
}
.contrast button:hover span {
  color: white;
}
.contrast button:hover span svg {
  color: white;
}
.contrast button:hover img {
  filter: brightness(0) invert(1) !important;
}
.contrast .header-content button span svg {
  color: #333 !important;
}
.contrast .left-side,
.contrast .right-side {
  border-radius: 0 !important;
  box-shadow: none !important;
  background: transparent !important;
}
.contrast .main-content .actions .slide-control button span svg,
.contrast .main-content .actions .zoom button span svg {
  color: yellow !important;
}
.contrast .main-content .actions .slide-control button:hover,
.contrast .main-content .actions .zoom button:hover {
  background: transparent !important;
}
.contrast .minutiae {
  background-color: transparent !important;
}
.contrast .minutiae .minutiae-container {
  background-color: transparent !important;
}
.contrast .edit-button {
  color: #00a84a !important;
  border-color: #00a84a !important;
  background-color: transparent !important;
}
.contrast .edit-button:hover {
  color: #fff !important;
  border-color: #fff !important;
  background-color: #00a84a !important;
}
.contrast .delete-button {
  color: #db3236 !important;
  border-color: #db3236 !important;
  background-color: transparent !important;
}
.contrast .delete-button:hover {
  color: #fff !important;
  border-color: #fff !important;
  background-color: #db3236 !important;
}
.contrast .primary-button {
  background-color: #00a84a !important;
}
.contrast .primary-button span {
  color: #fff !important;
}
.contrast .primary-button:hover, .contrast .primary-button:focus {
  color: #fff;
  background: #008241;
  border: solid 1px #00a84a;
}
.contrast .secondary-button {
  background-color: transparent;
}
.contrast .secondary-button span {
  color: #00a84a;
}
.contrast .secondary-button:hover span, .contrast .secondary-button:focus span {
  color: #008241 !important;
}
.contrast .link-button {
  background: transparent;
}
.contrast .link-button span {
  color: yellow !important;
}
.contrast .ant-btn-primary[disabled],
.contrast .ant-btn-primary[disabled]:hover,
.contrast .ant-btn-primary[disabled]:focus,
.contrast .ant-btn-primary[disabled]:active {
  color: rgba(0, 0, 0, 0.25) !important;
  border-color: #d9d9d9 !important;
  background: #cecece !important;
  text-shadow: none !important;
  box-shadow: none !important;
}
.contrast button[type=submit] {
  background-color: #00a84a !important;
}
.contrast button[type=submit] span {
  color: #fff !important;
}
.contrast button[type=submit]:hover, .contrast button[type=submit]:focus {
  background: #008241;
}
.contrast .page-header-container .back-and-title .icon-back span svg,
.contrast .anticon-edit svg {
  color: #464a4e !important;
}
.contrast .page-header-container .actions-content .actions .action-button span,
.contrast .header-container button span {
  color: black !important;
}
.contrast .page-header-container .actions-content .actions .action-button:hover span,
.contrast .header-container button:hover span {
  color: white !important;
}
.contrast .span-warnings .ant-tag span:not(:first-child) {
  color: black !important;
}
.contrast .ant-col .box-style-with-border-and-padding {
  border: 1.5px solid #e5e7ec !important;
}
.contrast .ant-form-item-control-input-content .upload-button span,
.contrast .upload-button {
  color: #fff !important;
  background-color: transparent;
}
.contrast .dashboard-container .dashboard-content .content-top .notification .icon-notification span svg,
.contrast .observation-content button span svg {
  color: #00a84a !important;
}
.contrast .form-observation-content form {
  box-shadow: none !important;
}
.contrast .container-login {
  border: 1px solid #fff !important;
}
.contrast .container-login .login-page-container .primary-btn {
  border: 1px solid #389e0d !important;
  background-color: #00a84a;
}
.contrast .container-login .login-page-container .primary-btn span {
  color: #fff;
}
.contrast .container-login .login-page-container .link-btn:hover {
  color: yellow !important;
}
.contrast .ant-table-tbody .ant-table-cell-row-hover .action-column button span:focus {
  background-color: transparent !important;
}
.contrast .ant-table-tbody .ant-table-cell-row-hover .action-column button span:focus-within {
  background-color: transparent !important;
}`, "",{"version":3,"sources":["webpack://./src/styles/contrast.scss","webpack://./src/styles/colors.scss"],"names":[],"mappings":"AACA;EACE,uBAAA;AAAF;AACE;;;;;;;;;;;;;;EAcE,4BAAA;EACA,uBAAA;AACJ;AAEE;;;;;;;;;;;;;;;EAeE,uBAAA;AAAJ;AAII;;EAEE,sBAAA;AAFN;AAME;EACE,4BAAA;AAJJ;AAOE;EACE,uBAAA;EACA,YAAA;AALJ;AAQE;EACE,YAAA;AANJ;AASE;;EAEE,4BAAA;EACA,wBAAA;AAPJ;AAUE;EACE,wBAAA;AARJ;AAYE;;EAEE,kCAAA;AAVJ;AAaE;EACE,mBAAA;AAXJ;AAcE;EACE,uBAAA;AAZJ;AAeE;;;;;;;;EAWE,uBAAA;EACA,uBAAA;EACA,4BAAA;AAhBJ;AAmBE;EACE,iDAAA;AAjBJ;AAoBE;;;;EAIE,0CAAA;AAlBJ;AAqBE;EACE,uBAAA;AAnBJ;AAsBE;;EAEE,wBAAA;AApBJ;AAuBE;EACE,aAAA;AArBJ;AAwBE;EACE,qBAAA;AAtBJ;AAyBE;EACE,aAAA;AAvBJ;AA0BE;EACE,YAAA;AAxBJ;AA2BE;EACE,kCAAA;AAzBJ;AA2BI;EACE,aAAA;EACA,kCAAA;AAzBN;AA6BE;EACE,WAAA;EACA,qCAAA;EACA,wBAAA;AA3BJ;AA8BE;EACE,wBAAA;AA5BJ;AA+BE;EACE,wCAAA;AA7BJ;AA+BI;EACE,iBAAA;AA7BN;AAgCI;EACE,YAAA;EACA,mBAAA;AA9BN;AAkCM;EACE,6BAAA;AAhCR;AAmCM;EACE,aAAA;AAjCR;AAqCI;EACE,kCAAA;EACA,8BAAA;EACA,kCAAA;AAnCN;AAqCM;EACE,uBAAA;AAnCR;AAqCQ;EACE,YAAA;AAnCV;AAyCE;EACE,sCAAA;AAvCJ;AA0CE;EACE,iBAAA;AAxCJ;AA2CE;EACE,YAAA;AAzCJ;AA4CE;EACE,YAAA;AA1CJ;AA8CI;EACE,YAAA;AA5CN;AAgDM;EACE,uBAAA;AA9CR;AAkDQ;EACE,uBAAA;AAhDV;AAqDI;EACE,8BAAA;EACA,YAAA;AAnDN;AAsDI;;EAEE,YAAA;AApDN;AAuDI;EACE,uBAAA;AArDN;AAyDE;EACE,iBAAA;EACA,cAAA;AAvDJ;AAyDI;EACE,YAAA;AAvDN;AA2DE;EACE,iBAAA;EACA,UAAA;AAzDJ;AA8DM;EACE,kCAAA;AA5DR;AAgEQ;EACE,kCAAA;AA9DV;AAkEM;EACE,uBAAA;AAhER;AAoEQ;EACE,6BAAA;AAlEV;AAqEQ;EACE,uBAAA;AAnEV;AAuEM;EACE,uBAAA;AArER;AAwEM;;;EAGE,oCAAA;AAtER;AA4EI;EACE,uBAAA;AA1EN;AA6EI;EACE,yBAAA;AA3EN;AA+EE;EACE,iBAAA;AA7EJ;AAgFE;EACE,yBAAA;AA9EJ;AAiFE;;EAEE,kCAAA;EACA,WAAA;AA/EJ;AAkFE;;;;;;;;;;EAUE,sDAAA;EACA,kBAAA;EACA,WAAA;AAhFJ;AAmFE;EACE,YAAA;AAjFJ;AAoFE;EACE,yBAAA;AAlFJ;AAqFE;EACE,yBAAA;AAnFJ;AAsFE;EACE,yBAAA;EACA,8BAAA;EACA,gCAAA;AApFJ;AAuFE;EACE,yBAAA;EACA,8BAAA;EACA,gCAAA;AArFJ;AAwFE;;EAEE,sBAAA;AAtFJ;AAyFE;EACE,wBAAA;AAvFJ;AA0FE;EACE,kCAAA;AAxFJ;AA2FE;EACE,iCAAA;AAzFJ;AA4FE;;EAEE,yBAAA;AA1FJ;AA6FE;EACE,iBAAA;AA3FJ;AA8FE;EACE,SAAA;AA5FJ;AA+FE;EACE,oCAAA;AA7FJ;AAgGE;EACE,wCAAA;AA9FJ;AAgGI;EACE,wCAAA;AA9FN;AAiGI;EACE,kBAAA;EACA,YAAA;EACA,6BAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,2BAAA;AA/FN;AAiGM;EACE,kCAAA;EACA,qCAAA;AA/FR;AAkGM;EACE,qCAAA;AAhGR;AAqGE;EAGE,mCAAA;AArGJ;AAwGE;;;;;;EAME,2BAAA;EACA,sBAAA;AAtGJ;AAyGE;EACE,8BAAA;AAvGJ;AA0GE;EACE,gBAAA;AAxGJ;AA2GM;EACE,wBAAA;AAzGR;AA4GM;EACE,4BAAA;EAIA,WAAA;AA7GR;AA0GQ;EAFF;IAGI,4BAAA;EAvGR;AACF;AA2GM;EACE,aAAA;AAzGR;AA0GQ;EACE,aAAA;EACA,uBAAA;AAxGV;AA8GE;EACE,wBAAA;AA5GJ;AA8GE;EACE,oCAAA;EACA,qBAAA;AA5GJ;AA+GE;EACE,6BAAA;EACA,qBAAA;AA7GJ;AAgHE;EACE,4BAAA;AA9GJ;AAiHE;EACE,2BAAA;EACA,iCAAA;AA/GJ;AAkHE;;;;;;EAME,uBAAA;AAhHJ;AAmHE;EACE,iBAAA;AAjHJ;AAoHE;EACE,gBAAA;AAlHJ;AAqHE;EACE,gDAAA;AAnHJ;AAsHE;EACE,oCAAA;AApHJ;AAuHE;EACE,oCAAA;AArHJ;AAwHE;EACE,oCAAA;AAtHJ;AAyHE;EACE,uBAAA;AAvHJ;AA2HI;EACE,gBAAA;EACA,uBAAA;AAzHN;AA6HE;;;EAKE,oCAAA;AA7HJ;AAgIE;EACE,yBAAA;AA9HJ;AAiIE;EACE,wBAAA;AA/HJ;AAkIE;EACE,kCAAA;AAhIJ;AAmIE;EACE,yBAAA;AAjIJ;AAoIE;EACE,yBAAA;AAlIJ;AAqIE;EACE,yBAAA;AAnIJ;AAuII;EACE,uBAAA;AArIN;AAyIE;EACE,uBAAA;AAvIJ;AA0IE;EACE,kCAAA;AAxIJ;AA0II;EACE,sBAAA;AAxIN;AA4IE;EACE,wCAAA;EACA,WAAA;AA1IJ;AA6IE;EACE;;;4CAAA;AAxIJ;AA8IE;EACE,kCAAA;AA5IJ;AA+IE;EACE,uBAAA;AA7IJ;AAgJE;EACE,wBAAA;AA9IJ;AAiJE;EACE,yBAAA;EACA,gCAAA;AA/IJ;AAkJE;EACE,sBAAA;AAhJJ;AAmJE;EACE,sBAAA;AAjJJ;AAoJE;EACE,kCAAA;AAlJJ;AAqJE;EACE,sBAAA;AAnJJ;AAsJE;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAyCE,wCAAA;AAtJJ;AAyJE;EACE,wBAAA;AAvJJ;AA0JE;EACE,oCAAA;AAxJJ;AA2JE;EACE,WAAA;AAzJJ;AA+JI;;;EACE,wBAAA;AA3JN;AA6JM;;;EACE,wBAAA;AAzJR;AAiKM;;EACE,uBAAA;AA9JR;AAmKE;;EAEE,wBAAA;AAjKJ;AAoKE;;;EAGE,sBAAA;AAlKJ;AAqKE;;EAEE,sBAAA;AAnKJ;AAsKE;EACE,sBAAA;AApKJ;AAwKI;EACE,yBAAA;AAtKN;AAyKI;EACE,yBAAA;AAvKN;AA0KI;EACE,yBAAA;AAxKN;AA2KI;EACE,yBAAA;AAzKN;AA8KI;;EAEE,8BAAA;EAEA,sCAAA;AA7KN;AAiLE;EACE,kCAAA;AA/KJ;AAkLE;EACE,mCAAA;EACA,MAAA;AAhLJ;AAmLE;;;;;;EAME,wBAAA;AAjLJ;AAoLE;;;;;;EAME,uBAAA;AAlLJ;AAqLE;;EAEE,8BAAA;EACA,2CAAA;EACA,UAAA;AAnLJ;AA+LI;;;EACE,sBAAA;AA3LN;AA+LE;EACE,2BAAA;AA7LJ;AAgME;EAKE,wCAAA;AAlMJ;AA8LI;EACE,sBAAA;AA5LN;AAmMI;EACE,qBAAA;AAjMN;AA2MI;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAKE,wCAAA;AAhLN;AAqLI;EACE,iCAAA;AAnLN;AAqLM;EACE,sBAAA;AAnLR;AAwLM;EACE,yBAAA;AAtLR;AAyLM;EAKE,oCAAA;AA3LR;AAuLQ;EACE,sBAAA;AArLV;AA6LM;EACE,yBAAA;AA3LR;AA8LM;EAKE,oCAAA;AAhMR;AA4LQ;EACE,sBAAA;AA1LV;AAkMM;EACE,yBAAA;AAhMR;AAmMM;EAKE,oCAAA;AArMR;AAiMQ;EACE,sBAAA;AA/LV;AAuME;EACE,aAAA;EACA,cAAA;EACA,oCAAA;AArMJ;AAwME;EACE,oCAAA;AAtMJ;AA2MM;EACE,sBAAA;EACA,wCAAA;AAzMR;AA2MQ;EACE,6BAAA;AAzMV;AA+ME;EACE,yBAAA;AA7MJ;AAgNE;EACE,yBAAA;AA9MJ;AAiNE;EACE,yBAAA;AA/MJ;AAmNI;EACE,YAAA;AAjNN;AAmNM;EACE,uBAAA;AAjNR;AAqNI;EACE,YAAA;EACA,uBAAA;AAnNN;AAqNM;EACE,YAAA;AAnNR;AAqNQ;EACE,YAAA;AAnNV;AAuNM;EACE,0CAAA;AArNR;AA0NE;EACE,sBAAA;AAxNJ;AA2NE;;EAEE,2BAAA;EACA,2BAAA;EACA,kCAAA;AAzNJ;AA8NI;;EACE,wBAAA;AA3NN;AA8NI;;EACE,kCAAA;AA3NN;AA+NE;EACE,wCAAA;AA7NJ;AA+NI;EACE,wCAAA;AA7NN;AAiOE;EACE,yBAAA;EACA,gCAAA;EACA,wCAAA;AA/NJ;AAiOI;EACE,sBAAA;EACA,6BAAA;EACA,oCAAA;AA/NN;AAmOE;EACE,yBAAA;EACA,gCAAA;EACA,wCAAA;AAjOJ;AAmOI;EACE,sBAAA;EACA,6BAAA;EACA,oCAAA;AAjON;AAqOE;EACE,oCAAA;AAnOJ;AAqOI;EACE,sBAAA;AAnON;AAsOI;EAEE,WAAA;EACA,mBC1+BU;ED2+BV,yBAAA;AArON;AAyOE;EACE,6BAAA;AAvOJ;AAyOI;EACE,cCv/BU;ADgxBhB;AA4OM;EACE,yBAAA;AA1OR;AA+OE;EACE,uBAAA;AA7OJ;AA+OI;EACE,wBAAA;AA7ON;AAiPE;;;;EAIE,qCAAA;EACA,gCAAA;EACA,8BAAA;EACA,4BAAA;EACA,2BAAA;AA/OJ;AAkPE;EACE,oCAAA;AAhPJ;AAkPI;EACE,sBAAA;AAhPN;AAmPI;EAEE,mBC1hCU;ADwyBhB;AAsPE;;EAEE,yBAAA;AApPJ;AAyPI;;EACE,uBAAA;AAtPN;AAwPI;;EACE,uBAAA;AArPN;AA2PM;EACE,uBAAA;AAzPR;AA8PE;EACE,sCAAA;AA5PJ;AA+PE;;EAEE,sBAAA;EACA,6BAAA;AA7PJ;AAgQE;;EAQE,yBAAA;AApQJ;AAuQE;EACE,2BAAA;AArQJ;AAwQE;EACE,iCAAA;AAtQJ;AAyQM;EACE,oCAAA;EACA,yBAAA;AAvQR;AAyQQ;EACE,WAAA;AAvQV;AA2QM;EACE,wBAAA;AAzQR;AAmRY;EACE,wCAAA;AAjRd;AAmRY;EACE,wCAAA;AAjRd","sourcesContent":["@import 'colors';\n.contrast {\n  background-color: black;\n  nav,\n  div,\n  ul,\n  li,\n  header,\n  footer,\n  section,\n  main,\n  aside,\n  form,\n  article,\n  body,\n  #optional-content .document-form,\n  .rectify-container .rectify-collapse .ant-collapse {\n    background: black !important;\n    color: white !important;\n  }\n\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6,\n  p,\n  label,\n  strong,\n  em,\n  cite,\n  q,\n  i,\n  b,\n  u {\n    color: white !important;\n  }\n\n  .panel .finger-prints .finger-print .overlay {\n    h3,\n    span {\n      color: #000 !important;\n    }\n  }\n\n  ul {\n    background: black !important;\n  }\n\n  li:hover {\n    background-color: white;\n    color: black;\n  }\n\n  span svg {\n    color: black;\n  }\n\n  a,\n  .data-row span {\n    background: black !important;\n    color: yellow !important;\n  }\n\n  .ant-form-item-explain-error {\n    color: yellow !important;\n  }\n\n  // input[type=button],\n  form,\n  #optional-content .document-form {\n    border: 1px solid white !important;\n  }\n\n  form {\n    border-radius: 15px;\n  }\n\n  input[type='search'] {\n    color: black !important;\n  }\n\n  input[type=url],\n  input[type=email],\n  input[type=tel],\n  input[type=date],\n  input[type=month],\n  input[type=week],\n  input[type=datetime],\n  input[type=datetime-local]\n\n  /* textarea */ {\n    // input[type=number]\n    border: 1px solid white;\n    color: white !important;\n    background: black !important;\n  }\n\n  img.on-contrast-force-gray {\n    filter: grayscale(100%) contrast(120%) !important;\n  }\n\n  .img-hand-right img,\n  .img-hand-left img,\n  img.on-contrast-force-white,\n  .coleta-data-body-especial .signature {\n    filter: brightness(0) invert(1) !important;\n  }\n\n  span {\n    color: white !important;\n  }\n\n  .ant-form-item-explain.ant-form-item-explain-error div,\n  .accessibitity-title span {\n    color: yellow !important;\n  }\n\n  .accessibility-bar ul li a.item-accessibility span {\n    color: yellow;\n  }\n\n  .footer .content .infos li img {\n    filter: brightness(5);\n  }\n\n  .card-item .card-text h4.title span {\n    color: yellow;\n  }\n\n  .contrast .card-item .card-text h3 {\n    color: white;\n  }\n\n  .ant-dropdown ul li {\n    background-color: black !important;\n\n    &:hover span {\n      color: yellow;\n      background-color: black !important;\n    }\n  }\n\n  .ant-tooltip-inner {\n    color: #fff;\n    background-color: rgba(0, 0, 0, 0.75);\n    border: 1px solid yellow;\n  }\n\n  .ant-tooltip-arrow-content {\n    background-color: yellow;\n  }\n\n  .ant-modal {\n    background-color: transparent !important;\n\n    .ant-radio-group.ant-radio-group-solid {\n      padding-top: 1rem;\n    }\n\n    div {\n      border: none;\n      border-radius: 30px;\n    }\n\n    .ant-modal-close {\n      &:hover {\n        background-color: transparent;\n      }\n\n      svg {\n        color: yellow;\n      }\n    }\n\n    .ant-modal-content {\n      border: 1px solid white !important;\n      border-radius: 30px !important;\n      background-color: black !important;\n\n      form {\n        border: none !important;\n\n        span {\n          color: white;\n        }\n      }\n    }\n  }\n\n  .ant-input-group-addon {\n    border: 1.5px solid #d9d9d9 !important;\n  }\n\n  .ant-card-bordered {\n    border-width: 2px;\n  }\n\n  .ant-menu li span a span {\n    color: white;\n  }\n\n  .ant-table-column-sort {\n    color: black;\n  }\n\n  .ant-table-tbody {\n    tr.ant-table-row td button span svg {\n      color: white;\n    }\n\n    tr.ant-table-row:hover td button {\n      span svg {\n        color: black !important;\n      }\n\n      &:hover {\n        span svg {\n          color: white !important;\n        }\n      }\n    }\n\n    tr.ant-table-row:hover > td.ant-table-cell {\n      background: #fafafa !important;\n      color: black;\n    }\n\n    tr.ant-table-row:focus-within > td.ant-table-cell,\n    tr.ant-table-row:focus-within > td.ant-table-cell span {\n      color: black;\n    }\n\n    tr.ant-table-row:hover > td.ant-table-cell span {\n      color: black !important;\n    }\n  }\n\n  span.ant-tag-warning {\n    background: white;\n    margin: 0 10px;\n\n    span {\n      color: black;\n    }\n  }\n\n  td.ant-table-cell.ant-table-cell-fix-right.ant-table-cell-fix-right-first {\n    background: black;\n    z-index: 1;\n  }\n\n  table {\n    tr {\n      td div {\n        background: transparent !important;\n      }\n\n      td span {\n        span {\n          background: transparent !important;\n        }\n      }\n\n      &:hover td div {\n        color: black !important;\n      }\n\n      &:hover td button {\n        &:hover {\n          background-color: transparent;\n        }\n\n        svg {\n          color: black !important;\n        }\n      }\n\n      &::selection td div {\n        color: black !important;\n      }\n\n      .date-three-week,\n      .date-two-week,\n      .date-three-week {\n        background-color: $status-invalid !important;\n      }\n    }\n  }\n\n  .ant-table-column-sorters {\n    span svg {\n      color: white !important;\n    }\n\n    .active svg {\n      color: #fd820f !important;\n    }\n  }\n\n  .ant-table-thead th.ant-table-column-has-sorters {\n    background: black;\n  }\n\n  .ant-select-arrow .anticon > svg {\n    color: #637178 !important;\n  }\n\n  .ant-input,\n  .ant-input-affix-wrapper {\n    background-color: white !important;\n    color: #000;\n  }\n\n  .ant-input:focus,\n  .ant-input-focused,\n  .ant-select:focus,\n  .ant-select-focused,\n  .ant-input-number:focus,\n  .ant-input-number-focused,\n  .ant-input-affix-wrapper:focus,\n  .ant-input-affix-wrapper-focused,\n  .ant-picker:focus,\n  .ant-picker-focused {\n    box-shadow: 0 0 0 2px rgba(0, 168, 74, 0.5) !important;\n    border-radius: 2px;\n    color: #000;\n  }\n\n  .page-content-login .container-login .ant-input {\n    color: black;\n  }\n\n  .ant-menu span svg {\n    color: #00a84a !important;\n  }\n\n  .manager-header .icon-table svg {\n    color: #00a84a !important;\n  }\n\n  .ant-tag-volcano {\n    color: #d4380d !important;\n    background: #fff2e8 !important;\n    border-color: #ffbb96 !important;\n  }\n\n  .ant-tag-green {\n    color: #389e0d !important;\n    background: #f6ffed !important;\n    border-color: #b7eb8f !important;\n  }\n\n  .textual-data .data-item div,\n  .textual-data .data-item span {\n    color: #fff !important;\n  }\n\n  .textual-data .data-item h3 {\n    color: yellow !important;\n  }\n\n  .ant-switch-handle {\n    background: transparent !important;\n  }\n\n  .ant-modal-content {\n    background-color: #fff !important;\n  }\n\n  .ant-modal-confirm-warning .ant-modal-confirm-body .anticon,\n  .ant-modal-confirm-confirm .ant-modal-confirm-body .anticon {\n    color: #faad14 !important;\n  }\n\n  .ant-modal-confirm-body .ant-modal-confirm-title {\n    color: whitesmoke;\n  }\n\n  .ant-input-search > .ant-input-group > .ant-input-group-addon:last-child {\n    left: 4px;\n  }\n\n  .ant-switch {\n    background-color: #cecece !important;\n  }\n\n  .ant-notification {\n    background-color: transparent !important;\n\n    div {\n      background-color: transparent !important;\n    }\n\n    .ant-notification-notice {\n      position: relative;\n      width: 384px;\n      max-width: calc(100vw - 24px * 2);\n      margin-bottom: 16px;\n      margin-left: auto;\n      padding: 16px 24px;\n      overflow: hidden;\n      line-height: 1.5715;\n      word-wrap: break-word;\n      background: #fff !important;\n\n      .ant-notification-notice-close {\n        background: transparent !important;\n        color: rgba(0, 0, 0, 0.45) !important;\n      }\n\n      .ant-notification-notice-message {\n        color: rgba(0, 0, 0, 0.85) !important;\n      }\n    }\n  }\n\n  .ant-picker-time-panel-column\n    > li.ant-picker-time-panel-cell-selected\n    .ant-picker-time-panel-cell-inner {\n    border: 1px solid yellow !important;\n  }\n\n  .ant-input-number-handler-wrap,\n  .ant-picker,\n  .ant-picker-input,\n  .ant-input-number-input-wrap,\n  .ant-input-number,\n  .ant-select {\n    background: #fff !important;\n    color: #000 !important;\n  }\n\n  .ant-switch-checked {\n    background: #00a84a !important;\n  }\n\n  .dashboard-container .dashboard-content {\n    overflow: hidden;\n\n    .ant-steps {\n      .ant-steps-icon-dot {\n        z-index: 9999 !important;\n      }\n\n      .ant-steps-item-tail {\n        background: white !important;\n        @media (max-width: 576px) {\n          background: black !important;\n        }\n        z-index: 10;\n      }\n\n      .ant-steps-icon .anticon-check {\n        z-index: 9999;\n        svg {\n          z-index: 9999;\n          color: white !important;\n        }\n      }\n    }\n  }\n\n  .ant-steps-item.ant-steps-item-process.ant-steps-item-active span.anticon {\n    display: none !important;\n  }\n  .request-form-content .ant-steps-item-process .ant-steps-item-icon {\n    background-color: #00a84a !important;\n    z-index: 9 !important;\n  }\n\n  .request-form-content .ant-steps-item-icon {\n    position: relative !important;\n    z-index: 9 !important;\n  }\n\n  .location-search div {\n    background: white !important;\n  }\n\n  .local-selection .location-search .ant-input-affix-wrapper {\n    box-shadow: none !important;\n    background-color: #fff !important;\n  }\n\n  .page-content .request-to-other-horizontal-form,\n  .page-content .request-type-horizontal-form,\n  .scheduling-content form,\n  form.ant-form-vertical,\n  .contrast .ant-input-group-addon,\n  .notification .notification-manager:nth-child(1) {\n    border: none !important;\n  }\n\n  .local-selection {\n    border: 1px solid;\n  }\n\n  .ant-radio-button-wrapper {\n    background: #000;\n  }\n\n  .ant-modal-mask {\n    background-color: rgba(0, 0, 0, 0.45) !important;\n  }\n\n  .start {\n    background-color: $primary-color !important;\n  }\n\n  .middle {\n    background-color: #ee9e00 !important;\n  }\n\n  .end {\n    background-color: #f84d4d !important;\n  }\n\n  .request-form-content span {\n    color: white !important;\n  }\n\n  .ant-picker-content tr {\n    .ant-picker-cell .ant-picker-cell-inner {\n      background: none;\n      color: white !important;\n    }\n  }\n\n  .ant-picker-cell-in-view.ant-picker-cell-range-start:not(\n      .ant-picker-cell-range-start-single\n    )::before,\n  .ant-picker-cell-in-view.ant-picker-cell-in-range::before,\n  .ant-picker-dropdown .ant-picker-cell-selected .ant-picker-cell-inner {\n    background-color: #00a84a !important;\n  }\n\n  .ant-picker-cell-disabled {\n    background-color: #cecece;\n  }\n\n  .ant-picker-header button span {\n    color: yellow !important;\n  }\n\n  .ant-picker-range-separator {\n    background-color: white !important;\n  }\n\n  .ant-select-selector .ant-select-selection-item {\n    color: #637178 !important;\n  }\n\n  .ant-select-selector span {\n    color: #6d7a7c !important;\n  }\n\n  span.required {\n    color: #ff4d4f !important;\n  }\n\n  .ant-upload-list-item-info {\n    .ant-upload-list-item-name span {\n      color: white !important;\n    }\n  }\n\n  .optional-documents span {\n    color: white !important;\n  }\n\n  .ant-table-column-sorters {\n    background: transparent !important;\n\n    span {\n      color: #333 !important;\n    }\n  }\n\n  .ant-table-row .ant-table-column-sort {\n    background-color: transparent !important;\n    color: #fff;\n  }\n\n  .background-login {\n    /* background-image: url('./../assets/img/illustration.png') !important;\n    background-repeat: no-repeat !important;\n    background-size: contain !important;\n    background-position: 30% 50% !important; */\n  }\n\n  .page-content-login {\n    background: transparent !important;\n  }\n\n  .ant-breadcrumb span.ant-breadcrumb-link a {\n    color: white !important;\n  }\n\n  .ant-breadcrumb span {\n    color: yellow !important;\n  }\n\n  .ant-modal-content .ant-modal-body .ant-btn-primary {\n    background-color: #00a84a;\n    border-color: #00a84a !important;\n  }\n\n  .ant-modal .ant-btn .ant-btn-primary span {\n    color: #fff !important;\n  }\n\n  .ant-modal .ant-btn .secondary-button span {\n    color: #000 !important;\n  }\n\n  .ant-modal-wrap {\n    background: transparent !important;\n  }\n\n  .anticon-search svg {\n    color: #333 !important;\n  }\n\n  .panel .finger-prints .finger-print .overlay,\n  .finger-print .selected,\n  .panel .finger-prints .finger-print,\n  .panel .finger-prints .finger-print .overlay .ant-notification-notice-message,\n  .content-top,\n  .box-footer,\n  .rg-content,\n  .grid-template-areas,\n  .grid-template-areas > *,\n  .photo > .img,\n  .signature-content,\n  .signature-content .img,\n  .director-signature-content,\n  .director-signature-content .img,\n  .grid-template-areas-bottom-right > *,\n  .grid-template-areas-top-right > *,\n  .grid-template-areas-bottom-right,\n  .grid-template-areas-top-right,\n  .resume-form .card-style-with-border,\n  .rg-mirror,\n  .coleta-data-body-especial,\n  .coleta-data-body,\n  .collect-data .header,\n  .ant-modal-footer,\n  .ant-modal-header,\n  .request-data > .actions,\n  .request-content,\n  .request-content .textual-data,\n  .request-data .header,\n  .ant-select-selection-overflow,\n  .ant-select-selection-overflow-item,\n  .ant-select-selection-overflow-item.ant-select-selection-overflow-item-suffix,\n  .ant-select-selection-search,\n  .ReactCrop__crop-selection,\n  .document .form,\n  .ant-back-top-icon span,\n  .ant-back-top-content,\n  .ant-back-top,\n  .ant-picker-cell-in-view.ant-picker-cell-range-end:not(\n      .ant-picker-cell-range-end-single\n    )::before {\n    background-color: transparent !important;\n  }\n\n  .ant-back-top-icon span svg {\n    color: yellow !important;\n  }\n\n  .select-container .actions-select {\n    background-color: #f1f3f4 !important;\n  }\n\n  .demands-form {\n    padding: 1%;\n  }\n\n  .observation-item,\n  .ant-modal-close-x,\n  .finish-info h3 {\n    span {\n      color: yellow !important;\n\n      svg {\n        color: yellow !important;\n      }\n    }\n  }\n\n  .icon-back,\n  .left-container {\n    span {\n      svg {\n        color: white !important;\n      }\n    }\n  }\n\n  .location-name span svg,\n  .ant-btn-link span {\n    color: yellow !important;\n  }\n\n  .ant-pagination button span svg,\n  .header-title button span svg,\n  .actions button svg {\n    color: #333 !important;\n  }\n\n  .actions button:hover svg,\n  .ant-upload-text-icon svg {\n    color: #fff !important;\n  }\n\n  .ant-pagination button:hover span svg {\n    color: #fff !important;\n  }\n\n  .header .status {\n    span.valid svg {\n      color: #3cba54 !important;\n    }\n\n    span.invalid svg {\n      color: #db3236 !important;\n    }\n\n    span.doubt svg {\n      color: #722ed1 !important;\n    }\n\n    span.pending svg {\n      color: #f4c20d !important;\n    }\n  }\n\n  .ant-modal-content .validation-itens {\n    .box-style-with-border,\n    .box-style-with-border-and-padding {\n      border-radius: 14px !important;\n      // box-shadow: 0px 2px 10px #0000001a;\n      border: 1.5px solid #e5e7ec !important;\n    }\n  }\n\n  .grid-template-areas .name {\n    background: transparent !important;\n  }\n\n  .request-page .ant-tabs .ant-tabs-ink-bar {\n    background-color: yellow !important;\n    top: 0;\n  }\n\n  .titleContainer,\n  .observation-item h3,\n  .historic-item h3,\n  .request-page .ant-tabs-nav .ant-tabs-tab-active,\n  .request-page .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn,\n  .request-page .ant-tabs-tab-btn:focus {\n    color: yellow !important;\n  }\n\n  .observation-content .observation-item span,\n  .observation-content .observation-item h4,\n  .historic-item span,\n  .historic-item h4,\n  .request-page .ant-tabs-nav,\n  .request-page .ant-tabs-tab-btn {\n    color: white !important;\n  }\n\n  .card-style-with-border,\n  .card-style-with-border-and-padding {\n    border-radius: 30px !important;\n    box-shadow: 0px 2px 10px #cecece !important;\n    z-index: 9;\n  }\n\n  .ant-upload-list-item-info,\n  .modal-optional-documents\n    .form-optional-documents\n    .optional-documents\n    .ant-checkbox-wrapper,\n  .modal-optional-documents\n    .form-optional-documents\n    .health-condition\n    .ant-checkbox-wrapper {\n    span {\n      color: #fff !important;\n    }\n  }\n\n  .modal-optional-documents .form-optional-documents .health-condition {\n    border-top: none !important;\n  }\n\n  .cancel-button {\n    span {\n      color: #fff !important;\n    }\n\n    background-color: transparent !important;\n  }\n\n  .ant-modal-confirm-body-wrapper {\n    .warning-icon svg {\n      color: red !important;\n    }\n  }\n\n  .request-data.DOUBT,\n  .request-data.PENDING,\n  .request-data.ALTERED,\n  .request-data.ACCEPT,\n  .request-data.FORGOTTEN,\n  .request-data.REJECT {\n    .header,\n    .header-subtitle,\n    .request-content,\n    .actions-row,\n    .actions {\n      background-color: transparent !important;\n    }\n  }\n\n  .request-data .actions {\n    .document-btn {\n      border: 2px solid #fff !important;\n\n      span {\n        color: #fff !important;\n      }\n    }\n\n    .doubt {\n      span {\n        color: $status-doubt !important;\n      }\n\n      &.selected {\n        span {\n          color: #000 !important;\n        }\n\n        background-color: $status-doubt !important;\n      }\n    }\n\n    .valid {\n      span {\n        color: $status-valid !important;\n      }\n\n      &.selected {\n        span {\n          color: #000 !important;\n        }\n\n        background-color: $status-valid !important;\n      }\n    }\n\n    .invalid {\n      span {\n        color: $status-invalid !important;\n      }\n\n      &.selected {\n        span {\n          color: #000 !important;\n        }\n\n        background-color: $status-invalid !important;\n      }\n    }\n  }\n\n  .request-data .justificative {\n    padding: 15px;\n    display: block;\n    background-color: #db3236 !important;\n  }\n\n  .request-data .doubt-box {\n    background-color: #722ed1 !important;\n  }\n\n  .justificative-modal {\n    .ant-modal-body {\n      .doubt-area {\n        color: #fff !important;\n        background-color: transparent !important;\n\n        &:focus {\n          border-color: #fff !important;\n        }\n      }\n    }\n  }\n\n  .anticon.ant-notification-notice-icon-success svg {\n    color: #52c41a !important;\n  }\n\n  .anticon.ant-notification-notice-icon-warning svg {\n    color: #faad14 !important;\n  }\n\n  .anticon.ant-notification-notice-icon-error svg {\n    color: #ff4d4f !important;\n  }\n\n  button {\n    span {\n      color: black;\n\n      svg {\n        color: white !important;\n      }\n    }\n\n    &:hover {\n      color: white;\n      background-color: black;\n\n      span {\n        color: white;\n\n        svg {\n          color: white;\n        }\n      }\n\n      img {\n        filter: brightness(0) invert(1) !important;\n      }\n    }\n  }\n\n  .header-content button span svg {\n    color: #333 !important;\n  }\n\n  .left-side,\n  .right-side {\n    border-radius: 0 !important;\n    box-shadow: none !important;\n    background: transparent !important;\n  }\n\n  .main-content .actions .slide-control button,\n  .main-content .actions .zoom button {\n    span svg {\n      color: yellow !important;\n    }\n\n    &:hover {\n      background: transparent !important;\n    }\n  }\n\n  .minutiae {\n    background-color: transparent !important;\n\n    .minutiae-container {\n      background-color: transparent !important;\n    }\n  }\n\n  .edit-button {\n    color: $primary-color !important;\n    border-color: $primary-color !important;\n    background-color: transparent !important;\n\n    &:hover {\n      color: #fff !important;\n      border-color: #fff !important;\n      background-color: $primary-color !important;\n    }\n  }\n\n  .delete-button {\n    color: $status-invalid !important;\n    border-color: $status-invalid !important;\n    background-color: transparent !important;\n\n    &:hover {\n      color: #fff !important;\n      border-color: #fff !important;\n      background-color: $status-invalid !important;\n    }\n  }\n\n  .primary-button {\n    background-color: $primary-color !important;\n\n    span {\n      color: #fff !important;\n    }\n\n    &:hover,\n    &:focus {\n      color: #fff;\n      background: $hover-primary;\n      border: solid 1px $primary-color;\n    }\n  }\n\n  .secondary-button {\n    background-color: transparent;\n\n    span {\n      color: $primary-color;\n    }\n\n    &:hover,\n    &:focus {\n      span {\n        color: $hover-primary !important;\n      }\n    }\n  }\n\n  .link-button {\n    background: transparent;\n\n    span {\n      color: yellow !important;\n    }\n  }\n\n  .ant-btn-primary[disabled],\n  .ant-btn-primary[disabled]:hover,\n  .ant-btn-primary[disabled]:focus,\n  .ant-btn-primary[disabled]:active {\n    color: rgba(0, 0, 0, 0.25) !important;\n    border-color: #d9d9d9 !important;\n    background: #cecece !important;\n    text-shadow: none !important;\n    box-shadow: none !important;\n  }\n\n  button[type='submit'] {\n    background-color: $primary-color !important;\n\n    span {\n      color: #fff !important;\n    }\n\n    &:hover,\n    &:focus {\n      background: $hover-primary;\n    }\n  }\n\n  .page-header-container .back-and-title .icon-back span svg,\n  .anticon-edit svg {\n    color: #464a4e !important;\n  }\n\n  .page-header-container .actions-content .actions .action-button,\n  .header-container button {\n    span {\n      color: black !important;\n    }\n    &:hover span {\n      color: white !important;\n    }\n  }\n\n  .span-warnings {\n    .ant-tag {\n      span:not(:first-child) {\n        color: black !important;\n      }\n    }\n  }\n\n  .ant-col .box-style-with-border-and-padding {\n    border: 1.5px solid #e5e7ec !important;\n  }\n\n  .ant-form-item-control-input-content .upload-button span,\n  .upload-button {\n    color: #fff !important;\n    background-color: transparent;\n  }\n\n  .dashboard-container\n    .dashboard-content\n    .content-top\n    .notification\n    .icon-notification\n    span\n    svg,\n  .observation-content button span svg {\n    color: $primary-color !important;\n  }\n\n  .form-observation-content form {\n    box-shadow: none !important;\n  }\n\n  .container-login {\n    border: 1px solid #fff !important;\n\n    .login-page-container {\n      .primary-btn {\n        border: 1px solid #389e0d !important;\n        background-color: #00a84a;\n\n        span {\n          color: #fff;\n        }\n      }\n\n      .link-btn:hover {\n        color: yellow !important;\n      }\n    }\n  }\n\n  .ant-table-tbody {\n    .ant-table-cell-row-hover {\n      .action-column {\n        button {\n          span {\n            &:focus {\n              background-color: transparent !important;\n            }\n            &:focus-within {\n              background-color: transparent !important;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n// .ant-steps-dot .ant-steps-item-tail, .ant-steps-dot.ant-steps-small .ant-steps-item-tail {\n//   top: 2px;\n// }\n","$text-color: #464a4e;\n$title-color: #4a4f5d;\n$primary-color: #00a84a;\n$secondary-color: #50b570;\n$tertiary-color: #10a574;\n$quaternary-color: #00a84a;\n$hover-primary: #008241;\n$status-valid: #3cba54;\n$status-invalid: #db3236;\n$status-pending: #f4c20d;\n$status-doubt: #722ed1;\n$active-button: #4295ff;\n$inactive-button: #b7b7b7;\n$background-color: #f1f3f4;\n$black: #000000;\n$white: #ffffff;\n$printerTable-color: #00f26b1a;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
